import React, { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const AIAssistant = lazy(() => import('./AIAssistant'))

export const AI_ASSISTANT_PATH = {
  ROOT: '/ai-assistant',
}

const AIAssistantRoutes: RouteObject[] = [
  {
    path: '',
    element: <AIAssistant />,
  },
]

export default AIAssistantRoutes
